if (!customElements.get('cb-footer-season')) {
  customElements.define('cb-footer-season', class extends HTMLElement {
    connectedCallback() {
      try { this.data = JSON.parse(this.querySelector('[data-cb-fs-data]').textContent); } catch (e) { return; }
      this.T = this.data.t;
      this.MN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      this.renderMonth();
      this.setupSeal();
      this.setupCal();
      this.updateStatus();
      this.clock = setInterval(() => this.updateStatus(), 60000);
      if (matchMedia('(max-width: 899px)').matches) this.querySelectorAll('.cb-fs__col').forEach((d) => d.removeAttribute('open'));
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.classList.add('is-anim');
      this.io = new IntersectionObserver((es) => {
        if (es.some((x) => x.isIntersecting)) { this.classList.add('is-in'); this.io.disconnect(); }
      }, { threshold: 0.15 });
      this.io.observe(this);
    }

    disconnectedCallback() { clearInterval(this.clock); if (this.io) this.io.disconnect(); }

    la() {
      const p = new Intl.DateTimeFormat('en-US', { timeZone: 'America/Los_Angeles', month: 'numeric', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
      const g = (t) => (p.find((x) => x.type === t) || {}).value;
      return { m: +g('month'), wd: ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'].indexOf(g('weekday')), min: (+g('hour') % 24) * 60 + (+g('minute')) };
    }

    inS(f, m) { return f.s <= f.e ? (m >= f.s && m <= f.e) : (m >= f.s || m <= f.e); }

    renderMonth() {
      const m = this.la().m;
      if (m === +this.dataset.month) return;
      const esc = window.cbEsc;
      const MA = this.MN.map((x) => x.slice(0, 3)), T = this.T, F = this.data.flowers;
      const feat = F.filter((f) => this.inS(f, m)).slice(0, 3);
      this.querySelector('[data-cb-fs-month]').textContent = this.MN[m - 1];
      this.querySelector('[data-cb-fs-rows]').innerHTML = feat.map((f) => {
        const k = m === f.s ? 'just' : (m === f.e ? 'last' : 'until');
        const tag = k === 'just' ? T.just : (k === 'last' ? T.last : T.until_tag.replace('{month}', MA[f.e - 1]));
        return '<li class="cb-fs__row"><span class="cb-fs__mb" aria-hidden="true" data-shape="' + esc(f.shape) + '"><img src="' + esc(f.img) + '" alt="" width="160" height="160" loading="lazy" decoding="async"></span><span><span class="cb-fs__name cb-fs__serif">' + esc(f.name) + '</span><span class="cb-fs__span">' + esc(T.season) + ' ' + MA[f.s - 1] + '–' + MA[f.e - 1] + '</span></span><span class="cb-fs__chip cb-fs__chip--' + k + '">' + esc(tag) + '</span></li>';
      }).join('');
      const nm = m % 12 + 1;
      const stay = feat.filter((f) => this.inS(f, nm)).map((f) => f.name);
      const arrive = F.filter((f) => f.s === nm).map((f) => f.name);
      // Names inside a sentence: lowercase, "and" before the last one
      const list = (a) => { a = a.map((x) => x.toLowerCase()); return a.length > 1 ? a.slice(0, -1).join(', ') + ' and ' + a[a.length - 1] : a[0]; };
      let txt = stay.length ? list(stay) + ' ' + T.stay : '';
      if (arrive.length) txt += (txt ? '; ' : '') + list(arrive) + ' ' + T.arrive;
      txt = txt.charAt(0).toUpperCase() + txt.slice(1);
      this.querySelector('[data-cb-fs-next]').innerHTML = '<b>' + esc(T.next + ' ' + this.MN[nm - 1]) + '</b> · ' + esc((txt || T.newSeason) + '.');
    }

    setupSeal() {
      const seal = this.querySelector('[data-cb-fs-seal]');
      if (!seal) return;
      const small = matchMedia('(max-width: 899px)').matches;
      seal.querySelectorAll('.cb-fs__pt').forEach((p) => {
        const a = (small ? +p.dataset.a - 180 : +p.dataset.a) * Math.PI / 180, R = +p.dataset.r * (small ? 0.7 : 1);
        p.style.setProperty('--x', Math.round(Math.cos(a) * R) + 'px');
        p.style.setProperty('--y', Math.round(Math.sin(a) * R * 0.7) + 'px');
      });
      seal.addEventListener('click', () => {
        seal.classList.add('is-burst');
        clearTimeout(this.burst);
        this.burst = setTimeout(() => seal.classList.remove('is-burst'), 1400);
      });
    }

    setupCal() {
      const cal = this.querySelector('[data-cb-fs-cal]');
      if (cal) cal.addEventListener('click', () => cal.classList.toggle('is-lifted'));
    }

    updateStatus() {
      // Shop hours: window.cbTime (CB Time settings)
      const s = cbTime.shop(), T = this.T, open = s.open;
      const sub = open ? T.until.replace('{time}', s.closes) : (s.tomorrow ? T.opensTomorrow : T.opensAt).replace('{time}', s.opens);
      const html = '<span class="cb-fs__dot' + (open ? ' is-open' : '') + '"></span><b>' + (open ? T.open : T.closed) + '</b> · ' + sub;
      this.querySelectorAll('[data-cb-fs-status], [data-cb-fs-status-m]').forEach((el) => {
        el.innerHTML = el.hasAttribute('data-cb-fs-status') ? html + ' · ' : html;
        el.hidden = false;
      });
    }
  });
}
